import * as React from 'react'
import { FC, useState } from 'react'

import { EmbedWrapper } from './EmbedWrapper'
import { ENTITY_TYPES } from '@sales-center/common'
import { Form, Formik, FormikHelpers } from 'formik'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { TidalTextFormikField } from '@sales-center/components'
import DialogContent from '@mui/material/DialogContent'

interface FormValues {
  locationId: string
  name: string
}

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  locationId: string
  onClose: () => void
}

export const AddPaymentMethodForm: FC<Props> = (props: Props) => {
  const { entityId, entityType, locationId, onClose } = props
  const [nameOnCard, setNameOnCard] = useState<string>()
  const [submitted, setSubmitted] = useState<boolean>(false)

  const initialValues = {
    locationId,
    name: '',
  }
  return (
    <Formik
      initialValues={initialValues}
      validate={({ name }) => {
        if (!name.trim()) {
          return { name: 'Required' }
        }
        return {}
      }}
      onSubmit={(
        values: FormValues,
        { setSubmitting }: FormikHelpers<FormValues>,
      ) => {
        setSubmitting(true)
        setNameOnCard(values.name)
        setSubmitting(false)
        setSubmitted(true)
      }}
    >
      {({ isSubmitting, touched, errors, setFieldValue, values }) => (
        <>
          <DialogContent>
            <Form noValidate autoComplete="off">
              <Box pt={0.8}>
                <TidalTextFormikField
                  name="name"
                  label="Name on Card*"
                  disabled={submitted}
                  error={touched.name && !!errors.name}
                  helperText={errors.name}
                  inputProps={{
                    maxLength: 30,
                    'data-test-id': 'name-on-card-field',
                    onBlur: () => setFieldValue('name', values.name.trim()),
                  }}
                />
              </Box>
              {!submitted && (
                <Box mt={2} display="flex" gap={1} justifyContent="flex-end">
                  <Button
                    onClick={onClose}
                    variant="outlined"
                    data-test-id="payment-method-cancel-button"
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    type="submit"
                    variant="contained"
                    data-test-id="payment-method-enter-button"
                  >
                    Enter
                  </Button>
                </Box>
              )}
            </Form>
          </DialogContent>
          {!!nameOnCard && locationId && submitted && (
            <DialogContent sx={{ p: 0, minHeight: '346px' }}>
              <EmbedWrapper
                entityId={entityId}
                entityType={entityType}
                locationId={locationId}
                nameOnCard={nameOnCard}
                onClose={onClose}
              />
            </DialogContent>
          )}
        </>
      )}
    </Formik>
  )
}

AddPaymentMethodForm.displayName = 'AddPaymentMethodForm'
